import {KeySnapshot} from "../../api/Model";
import {mapSetState, SetState} from "../../util/FormHandlers";
import {FormControl} from "@mui/material";
import {KeySelect} from "../../components/key-select/KeySelect";
import React, {useMemo} from "react";
import {VaultKeys} from "../../api/VaultKeysStore";

const filterInVaultKeys = (vaultKeys: VaultKeys) =>
    vaultKeys.allKeys().filter(k => k.historyRecord.location.type === 'with-vault');

export function AssignKeyDialog({form, setForm}: {
    form: {keySnapshot: KeySnapshot | undefined},
    setForm: SetState<{keySnapshot: KeySnapshot | undefined}>,
}) {
    const setKeySnapshot = useMemo(
        () => mapSetState(setForm, 'keySnapshot'),
        [setForm]
    );

    return (
        <FormControl fullWidth sx={{mt: 1}} required>
            <KeySelect
                required
                label="Select Key"
                keySnapshot={form.keySnapshot}
                setKeySnapshot={setKeySnapshot}
                filterKeys={filterInVaultKeys}
                variant="outlined"
            />
        </FormControl>
    );
}